import { render, staticRenderFns } from "./fbaShip.vue?vue&type=template&id=2b20a0cd&scoped=true&"
import script from "./fbaShip.vue?vue&type=script&lang=js&"
export * from "./fbaShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20a0cd",
  null
  
)

export default component.exports